<template>
	<div :class="{'menu-folder-wrapper':colIndex > 0}">
        <div v-for="(menu, rowIndex) in menuData" :key="rowIndex" class="menu-folder" :class="{'menu-knowledge': menu.isKnowledge}">
            <!-- <div class="menu-title" :data="(menu.Type === 1) + '-' + (!menu.ChildList.length) + '-' + menu.Selected" @click="checkMenu(menu,rowIndex)" :class="{'KB-locat':menu.Type === 1 && !menu.ChildList.length && menu.Selected }"> -->
            <div class="menu-title" :data="(menu.Type === 1) + '-' + (!menu.ChildList.length) + '-' + menu.Selected" @click="checkMenu(menu,rowIndex)" :class="{'KB-locat':lowerCase(currentNode) == lowerCase(menu.KBInfoId) }">
                <div class="menu-icon-folder" :class="{'menu-icon-file':menu.Type === 1,'menu-icon-faq':menu.Type === 2,'menu-icon-active':menu.Selected && menu.Type === 0}"></div>
                <div class="menu-name" :class="{'menu-name-active': lowerCase(currentNode) == lowerCase(menu.KBInfoId)}" v-text="menu.Name"></div>
                <div class="menu-icon-triangle" :class="{'menu-icon-triangle-reverse': menu.ChildList.length>0 && menu.Selected}" v-if="menu.ChildList.length>0"></div>
            </div>
            <menu-folder :menuData="menu.ChildList" :LogId="LogId" :colIndex="colIndex + 1" v-if="menu.Type === 0 && menu.ChildList.length>0 && menu.Selected"></menu-folder>
        </div>
    </div>
</template>

<script>
	import store from '../../store/index'
    import { COMMON } from '../../api'
    export default {
        name: "menuFolder",
        props:['menuData','colIndex','LogId'],
		data(){
			return {
                currentRef:null
			}
		},
		components:{

		},
		created() {
		},
		mounted() {
            setTimeout(() => {
                if(document.querySelector('.KB-locat')) document.querySelector('.KB-locat').scrollIntoViewIfNeeded(true);
            },300)
		},
		methods: {
			checkMenu(menu,index) {
                this.menuData.map((e,i)=>{
                    if(i !== index) {
                        e.Selected = false
                        this.initData(e.ChildList)
                    };
                })
                if(menu.Type === 0) {
                    if(!menu.Selected) { //如果是收起状态
                        store.commit('SET_CurrentNode',menu.KBInfoId)
                        menu.Selected = true
                    }else{  //如果是展开  则收起
                        store.commit('SET_CurrentNode',null)
                        menu.Selected = false
                    }
                    // menu.Selected = !menu.Selected;
                    this.initData(menu.ChildList)
                }else{

                    //--------埋点-------
                    try{
                        let data = {
                            LogId:this.LogId,
                            KBInfoId:menu.KBInfoId,
                            KBName:menu.Name
                        }
                        COMMON.UpdateNodeViewData(data).then(()=>{
                            store.state.menu.showMenu = false;
                            document.querySelector("#app").style.overflow = "";
                            store.commit('SET_CurrentNode',menu.KBInfoId)
                            this.$router.push({
                                name: 'knowledge',
                                params: {
                                    uuid: menu.KBInfoId
                                }
                            })
                        })
                    }
                    catch (e) {
                        console.log(e);
                        store.state.menu.showMenu = false;
                        document.querySelector("#app").style.overflow = "";
                        store.commit('SET_CurrentNode',menu.KBInfoId)
                        this.$router.push({
                            name: 'knowledge',
                            params: {
                                uuid: menu.KBInfoId
                            }
                        })
                    }
                    //-------------------

                }

            },
            initData(data){
                if(data.length) {
                    data.map((e)=>{
                        e.Selected = false;
                        this.initData(e.ChildList)
                    })
                }
            },
            lowerCase(string){
                return string ? string.toLowerCase() : ''
            }
		},
        computed:{
            currentNode(){
                return store.getters.GET_CurrentNode
            }
        }
    }
</script>

<style lang="scss" scoped>
.menu-folder-wrapper{
    position: relative;
    &::before{
        content: '';
        position: absolute;
        width: 1px;
        height: calc(100% + .4rem);
        background-color: #F0F1F2;
        top: j(-15);
        left: j(12);
    }
}
.menu-folder{
    padding-left: j(50);
}
.menu-title{
    padding: j(30) 0;
    display: flex;
    .menu-icon-triangle{
        height: j(8);
        width: j(14);
        min-width: j(14);
        margin-left: j(10);
        margin-top: j(18);
        background-image: url('../../../static/images/arrow_down.png');
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
    }
    .menu-icon-folder{
        height: j(30);
        width: j(32);
        min-width: j(32);
        background-image: url('../../../static/images/Icon_Folder.png');
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        margin-right: j(20);
        margin-top: j(4);
    }
    .menu-icon-active{
        background-image: url('../../../static/images/Icon_Folder_open.png');
    }
    .menu-icon-file{
        background-image: url('../../../static/images/Icon_File.png');
    }
    .menu-name{
        font-size:j(28);
        font-weight:400;
        color:rgba(54,60,84,1);
        overflow: hidden;
        text-overflow:ellipsis;
        word-break: break-word;
        display: -webkit-box;
        /*!autoprefixer: off */
        -webkit-box-orient: vertical;
        /*autoprefixer: on */
        -webkit-line-clamp: 2;
    }
    .menu-name-active{
        color: #00bebe;
    }
    .menu-icon-triangle-reverse{
        // background-image: url('../../../static/images/arrow_up.png')
        transform: rotateX(180deg);
    }
}

</style>



// WEBPACK FOOTER //
// src/views/treeMenu/menuFolder.vue